import { useSelector } from "react-redux";
import { RootState } from "..";
import { OpportunitySearchQueryState } from "../context/OpportunitySearchQuery";
import { opportunitySearchQueryToString } from "./util";

export const useOpportunitySearchResult = (
  searchQuery?: OpportunitySearchQueryState
) => {
  const opportunityResult = useSelector(
    (state: RootState) => state.opportunityResult
  );

  const queryString = opportunitySearchQueryToString(searchQuery);

  return {
    ...opportunityResult,
    data: opportunityResult.data[queryString] || null,
  };
};
